import storage from 'utils/storage'

export default class Manager {
  constructor() {
    this.data = {}
    this.path = 'storage'
  }

  set path(newPath) {
    this._path = newPath
    this.restore()
  }

  get path() {
    return this._path
  }

  persist() {
    storage.set(this.path, this.data)
  }

  restore() {
    this.data = storage.get(this.path) || {}
  }

  setState(name, value) {
    this.data[name] = value
    this.persist()
  }

  removeState(name) {
    delete this.data[name]
    this.persist()
  }

  getState(name) {
    return this.data[name]
  }
}
